export default __webpack_public_path__ + "static/media/tabel-tegningshoved.8d9d0991.pdf";